export default {
    'ERROR-GET-ALL-CHALLENGES': {
        'CHALLENGE-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Le challenge demandé est introuvable.",
                en: 'The requested challenge was not found.',
            },
            redirectPath: '/challenges',
        },
    },
    'ERROR-START-CHALLENGE': {
        'CHALLENGE-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Le challenge demandé est introuvable.",
                en: 'The requested challenge was not found.',
            },
            redirectPath: '/challenges',
        },
        'USER-ALREADY-HAS-CHALLENGE': {
            actionType: 'toast',
            message: {
                fr: "Vous avez déjà commencé ce challenge.",
                en: 'You have already started this challenge.',
            },
        },
    },
    'ERROR-CHALLENGE-DONE-BY-HELPER': {
        'USER-CHALLENGE-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Le challenge demandé est introuvable.",
                en: 'The requested challenge was not found.',
            },
            redirectPath: '/challenges',
        },
        'USER-CHALLENGE-ALREADY-VALIDATED-OR-REFUSED': {
            actionType: 'toast',
            message: {
                fr: "Le challenge a déjà été validé ou refusé.",
                en: 'The challenge has already been validated or refused.',
            },
        },
        'USER-CHALLENGE-NO-CHALLENGE': {
            actionType: 'redirect',
            message: {
                fr: "Aucun challenge associé trouvé",
                en: 'No associated challenge found',
            },
            redirectPath: '/challenges',
        },
        'USER-CHALLENGE-NEED-LINK-PROOF': {
            actionType: 'toast',
            message: {
                fr: "Un lien est requis comme preuve pour ce challenge.",
                en: 'A link is required as proof for this challenge.',
            },
        },
        'USER-CHALLENGE-NEED-TEXT-PROOF': {
            actionType: 'toast',
            message: {
                fr: "Un texte est requis comme preuve pour ce challenge.",
                en: 'Text is required as proof for this challenge.',
            },
        },
        'USER-CHALLENGE-NEED-PHOTO-PROOF': {
            actionType: 'toast',
            message: {
                fr: "Une photo est requise comme preuve pour ce challenge.",
                en: 'A photo is required as proof for this challenge.',
            },
        },
    },
};
